import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { OfferDetailsInterface } from '../models/offer-details.interface';
import { VitrineOfferInterface } from '../models/vitrine-offer.interface';
import { environment } from '../../../../environments/environment';
import { MefOfferInterface } from '../models/mef-offer.interface';
import { RefillPassOptionInterface } from '../models/refill-pass-option.interface';
import { RefillOfferInterface } from '../models/refill-offer.interface';
import { CheckQuotaRateLimitResponseInterface } from '../models/check-quota-rate-limit-response.interface';

@Injectable()
export class OfferVitrineService {

  constructor(private apiService: ApiService) {}

  /**
   * Get change offers eligible list
   */
  changeOffersEligibleList(offerId: number, phoneNumber: string): Observable<Array<VitrineOfferInterface>> {
    let url = 'vitrine/sales/channel/offers/gsm/vitrine_gp';
    if (environment.data.brand === 'prixtel') {
      url = 'vitrine/change/offers/eligible/list/' + offerId + '/' + phoneNumber;
    }
    return this.apiService.get(url);
  }

  /**
   * Refill offers
   */
  getRefillOffers(offerId: number): Observable<Array<RefillOfferInterface>> {
    return this.apiService.get('vitrine/eligible/refill/offers/' + offerId);
  }

  /**
   * Get offer details
   */
  getOfferDetails(offerId: number): Observable<OfferDetailsInterface> {
    return this.apiService.get('vitrine/sales/channel/offer/' + offerId);
  }

  /**
   * Get available offers for a MEF offer
   */
  getAvailableOffers(phoneNumber: string): Observable<Array<MefOfferInterface>> {
    return this.apiService.get<Array<MefOfferInterface>>('eligible/gsm/offers/' + phoneNumber);
  }

  /**
   * Get refill options
   */
  getRefillOptions(carrier: string, channel: string, offerId: number): Observable<Array<RefillPassOptionInterface>> {
    return this.apiService.get<Array<RefillPassOptionInterface>>('vitrine/sales/channel/refill/options/' + carrier + '/' + channel + '/' + offerId);
  }

  /**
   * Get pass options
   */
  getPassOptions(carrier: string, channel: string, offerId: number): Observable<Array<RefillPassOptionInterface>> {
    return this.apiService.get<Array<RefillPassOptionInterface>>('vitrine/sales/channel/pass/options/' + carrier + '/' + channel + '/' + offerId);
  }

  /**
   * Check package rate limit
   * @param msisdn
   * @param quotaTypes
   */
  checkPackageRateLimit(msisdn: string, quotaTypes: string): Observable<CheckQuotaRateLimitResponseInterface> {
    return this.apiService.post<CheckQuotaRateLimitResponseInterface>('check/quotas', {msisdn, quotaTypes});
  }
}
